import { constructs } from "../api/contructs";
import { createSyncedApiHook } from "../api/createSyncedApiHook";
import { createUseItemHook, createUseItemsHook } from "./createUseItemsHook";

const construct = constructs.pipeline;

export const useSavedPipeline = createUseItemHook(construct);
export const useSavedPipelines = createUseItemsHook(construct);
export const useSavedPipelinesApi = createSyncedApiHook(construct);